<div class="header">
  <img
    (click)="onClose()"
    (keyup)="onClose()"
    tabindex="0"
    src="/assets/icons/close-modal.svg"
    alt="closeIcon"
    class="pointer"
  />
</div>
<div class="refill-box" #refillBox>
  <app-alert
    #alertComponent
    [text]="errorAlertText"
    [type]="2"
    [isForDialog]="true"
    *ngIf="showErrorAlert"
    (closeAlertEvent)="onAlertClosed()"
  ></app-alert>
  <div class="title-box">
    <h4>{{ 'serviceInsurance' | translate }}</h4>
    <p>{{ 'coverAnyIncident' | translate }}</p>
  </div>
  <div class="seleccion-importe">
    <h4>{{ 'selectInsuranceDays' | translate }}</h4>
    <div class="prices-box">
      <div *ngFor="let option of options; let i = index">
        <div
          [ngClass]="{ checked: selected === i }"
          (click)="selectOption(i)"
          (keydown)="selectOption(i)"
          tabindex="0"
        >
          <span class="price">{{ option.Days }} día</span>
          <span class="subtitle">{{ option.Price | currencyFormat }}</span>
        </div>
      </div>
    </div>
  </div>
  <form [formGroup]="insuranceForm" class="w-100">
    <div class="form-group">
      <label for="fullName">{{ 'full_name' | translate }}</label>
      <input
        type="text"
        id="fullName"
        formControlName="fullName"
        placeholder="Dani Parrales Rosa"
        [ngClass]="{
          'error-input': invalidForm && !insuranceForm.get('fullName')?.valid,
        }"
      />
      <div *ngIf="insuranceForm.get('fullName')?.invalid && invalidForm" class="error">
        {{ 'required' | translate }}
      </div>
    </div>
    <div class="form-group">
      <label for="tipo">{{ 'documentType' | translate }}</label>
      <select
        id="tipo"
        formControlName="tipo"
        [ngClass]="{
          'error-input': invalidForm && !insuranceForm.get('tipo')?.valid,
        }"
      >
        <option *ngFor="let type of filteredDocumentTypeOptions" [value]="type.value">
          {{ type.labelKey | translate }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <label for="numero">{{ 'documentNumber' | translate }}</label>
      <input
        type="text"
        id="numero"
        formControlName="numero"
        placeholder="12345678A"
        [ngClass]="{
          'error-input': invalidForm && !insuranceForm.get('numero')?.valid,
        }"
      />
      <div *ngIf="insuranceForm.get('numero')?.invalid && invalidForm" class="error">
        {{ 'required' | translate }}
      </div>
    </div>
  </form>
  <div class="footer">
    <button (click)="addTopping()">{{ 'add' | translate }}</button>
  </div>
</div>
